/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePrice } from './BasePrice';
const TenantAccessPlanParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('tenant-access-plan')],
    ['duration', parsers.duration],
    ['tenantId', codecString, 'tenant_id'],
]), BasePrice);
export class TenantAccessPlan extends BasePrice {
    static decode(input) {
        return TenantAccessPlanParser.decode(input).map(res => new TenantAccessPlan(res));
    }
    static unsafeDecode(input) {
        return TenantAccessPlan.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantAccessPlanParser.encode(data);
    }
    static schema() {
        return TenantAccessPlanParser.schema();
    }
}
